module.exports = __webpack_public_path__ + "static/media/FMB_icon7.b6e4d386.svg";